/* eslint-disable no-undef */
import getProductsInWishlist from './utils/getProductsInWishlist.js';
import Accordion from './components/accordion.js';
import renderProductCards from './utils/render-product-cards.js';
import './components/underlay.js';
import 'lite-youtube-embed';
import JudgeMe from './vendor/judge-me.js';

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(getProductsInWishlist);

document.addEventListener('searchanise:new-products-loaded', () =>
  getProductsInWishlist()
);

document.addEventListener('DOMContentLoaded', () => {
  // Set up scroll-to-able sections
  [...document.querySelectorAll('a[href^="#"]')]
    .filter(anchor => anchor.getAttribute('href') !== '#')
    .forEach(anchor => {
      const sectionIdentifier = anchor.getAttribute('href').replace('#', '');
      const linkableSection = document.querySelector(
        `[data-scroll-linkable="${sectionIdentifier}"]`
      );

      if (!linkableSection) {
        return;
      }

      anchor.addEventListener('click', e => {
        e.preventDefault();
        linkableSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    });

  // Set up accordions
  [...document.querySelectorAll('[data-accordion]')].forEach(
    accordion => new Accordion(accordion)
  );

  renderProductCards();
  JudgeMe();
});

renderProductCards();

function renderFancybox() {
  Fancybox.bind('[data-fancybox]', {
    // Your options go here
  });
}

// Check if there are any Fancyboxes on the page.
// If so, dynamically load the Fancybox script and CSS, then render the Fancybox.
function checkFancybox() {
  // Fancybox is only initialised on desktop, so no need to check otherwise.
  if (!window.matchMedia('(min-width: 1024px)').matches) return;

  const fancybox = document.querySelector('[data-fancybox]');
  if (fancybox) {
    // Load the script.
    const $script = document.createElement('script');
    $script.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js'
    );
    $script.addEventListener('load', () => {
      renderFancybox();
    });
    document.head.appendChild($script);

    // Load the CSS.
    const $link = document.createElement('link');
    $link.setAttribute('rel', 'stylesheet');
    $link.setAttribute(
      'href',
      'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css'
    );
    document.head.appendChild($link);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  checkFancybox();
});

// We need to listen for resize, incase the user goes from mobile
// to desktop, then we need to load in Fancybox.
window.addEventListener(
  'resize',
  () => {
    checkFancybox();
  },
  {
    passive: true,
  }
);
